import * as React from "react";

function SvgUserSettings({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path d="M0 0h24v24H0z" />
        <path d="M24 0v24H0V0z" />
        <path
          fill="currentColor"
          d="M10 11.241c1.485 0 2.966.25 4.277.72a5.6 5.6 0 012.728-.711 5.75 5.75 0 01.215 11.496l-.22.004-.22-.004A5.75 5.75 0 0111.25 17c0-1.494.605-2.877 1.578-3.912A11.615 11.615 0 0010 12.741c-3.885 0-7.1 1.821-7.245 4.083l-.005.159v3a.75.75 0 01-1.493.102l-.007-.102v-3c0-3.38 4.056-5.742 8.75-5.742zm7.003 1.509c-.774 0-1.511.223-2.148.609a.695.695 0 01-.193.125c-1.14.774-1.912 2.08-1.912 3.516a4.25 4.25 0 004.044 4.245l.206.004.206-.004a4.252 4.252 0 004.04-4.04L21.25 17a4.25 4.25 0 00-4.247-4.25zM17 14.25a.75.75 0 01.743.648l.007.102v.055c.198.076.386.184.557.322l.047-.026a.75.75 0 01.836 1.241l-.084.057-.047.028c.033.214.033.433 0 .647l.047.027a.75.75 0 01-.66 1.343l-.092-.045-.047-.026a2.06 2.06 0 01-.556.322L17.75 19a.75.75 0 01-1.493.102L16.25 19v-.055a2.055 2.055 0 01-.557-.322l-.052.029a.75.75 0 01-.827-1.248l.085-.056.042-.023a2.146 2.146 0 010-.65l-.042-.023a.749.749 0 01.65-1.348l.144.073c.171-.139.36-.246.557-.322V15a.75.75 0 01.75-.75zm.05 2.168l-.05.002-.029-.003a.58.58 0 00-.465.271l-.004.013-.01.01a.587.587 0 000 .578l.006.004a.572.572 0 00.485.29l.008-.003.027.004a.585.585 0 00.463-.916l-.068-.081-.08-.068a.583.583 0 00-.283-.1zM13 2.492a4.244 4.244 0 010 6 4.244 4.244 0 01-6 0 4.244 4.244 0 010-6 4.244 4.244 0 016 0zM8.06 3.553a2.744 2.744 0 000 3.878 2.741 2.741 0 004.006-3.74l-.128-.138-.137-.128a2.742 2.742 0 00-3.74.128z"
        />
      </g>
    </svg>
  );
}

export default SvgUserSettings;
